var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{staticClass:"mr-12",attrs:{"disabled":_vm.disabled,"error-messages":_vm.getErrors,"label":_vm.getLabelText(),"required":!_vm.isOptional,"value":_vm.value.item2,"placeholder":"xxxx,xx"},on:{"blur":_vm.validates,"change":_vm.onValueChange,"input":_vm.validates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }